import Vue from 'vue';
import langEn from 'element-ui/lib/locale/lang/en';
import langJp from 'element-ui/lib/locale/lang/ja';
import locale from 'element-ui/lib/locale';
import enums from 'vue-enums';
import App from '@/App.vue';
import i18n from '@/i18next';
import router from '@/router/router';
import store from '@/state/store';
import './plugins/element';
import 'font-awesome/css/font-awesome.min.css';
// import 'element-ui/packages/theme-chalk/src/index.scss';
import '@/assets/themes/verajohn/index.css';

Vue.use(enums);

Vue.config.productionTip = false;

new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
}).$mount('#app');
